
export default class CmsApi {


	/**
	 * Fetch a property by its slug
	 *
	 * @param {String} propertySlug
	 * @return {Promise<Property>}
	 */
	static fetchProperty(propertySlug) {
		return fetch(`/api/properties/${propertySlug}`)
			.then(response => response.json());
	}

	/**
	 *
	 * @return {Promise<Array<Property>>}
	 */
	static fetchProperties() {
		return fetch('/api/properties').then(rs => rs.json());
	}

	/**
	 *
	 * @param {Number} propertyId
	 * @param {Number} roomId
	 */
	static fetchRoom(propertyId, roomId) {
		return CmsApi.fetchProperties()
			.then(properties => properties.find(p => p.id === propertyId))
			.then(property => property.rooms.find(r => r.id === roomId));
	}

	/**
	 * @returns {Promise<Array<any>>}
	 */
	static fetchRestaurants() {
		return fetch('/api/restaurants').then(rs => rs.json());
	}

	/**
	 * @returns {Promise<Array<Offer>>}
	 */
	static fetchOffers() {
		return fetch('/api/properties/offers').then(rs => rs.json());
	}

	/**
	 *
	 * @return {Promise<Array<Place>>}
	 */
	static fetchPlaces() {
		return fetch('/api/places').then(rs => rs.json());
	}

	/**
	 *
	 * @param {String} blogID
	 * @return {Promise<Blog>}
	 */
	static fetchBlogs(blogID) {
		return fetch(`/api/blogs/${blogID}`).then(rs => rs.json());
	}

	/**
	 *
	 * @param {String} propertyId
	 * @param {String} roomId
	 */
	static fetchPropertyWithIntegration(propertyId, roomId) {
		return fetch(`/api/properties/integration/${propertyId}`)
			.then(response => {
				if (!response.ok) throw new Error('We could not find the property that you were looking for')
				return response.json()
			})
			.then(property => {
				property.rooms = property.rooms.filter(r => r.pmsId.includes(parseInt(roomId)));
				if (!property.rooms.length) throw new Error('We could not find the room that you were looking for');
				if (!property.pmsId) throw new Error('This property is not configured (missing PMS ID)');
				if (!property.rooms[0].pmsId.length) throw new Error('This room is not configured (missing PMS ID)');
				return property;
			});
	}

	/**
	 *
	 * @param {String} username
	 * @return {Promise<InstagramAccessTokenResponse>}
	 */
	static fetchInstagramToken(username) {
		return fetch(`/instagram/${username}/access-token`)
			.then(response => {
				if (!response.ok) throw new Error('Could not fetch Instagram token');
				return response.json();
			});
	}



}
